import { Reveal, MaskedLine } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { useContent } from "@/context/ContentContext";

export default function Faq() {
  const { faqGroups } = useContent();
  return (
    <>
      <section className="container-site pb-14 pt-16 sm:pt-24" data-testid="faq-hero">
        <p className="overline-label">FAQ</p>
        <h1 className="mt-5 max-w-3xl font-heading text-4xl font-semibold leading-[1.08] tracking-tight text-foreground sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.1}>Everything you're</MaskedLine>
          <MaskedLine delay={0.25}>
            <span className="text-terracotta-500">wondering, answered.</span>
          </MaskedLine>
        </h1>
      </section>

      <section className="container-site pb-24" data-testid="faq-groups">
        <div className="mx-auto max-w-3xl space-y-14">
          {faqGroups.map((group, gi) => (
            <Reveal key={group.title} delay={gi * 0.08}>
              <div>
                <h2 className="font-heading text-2xl font-semibold text-foreground">{group.title}</h2>
                <Accordion type="single" collapsible className="mt-6 w-full" data-testid={`faq-accordion-${group.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  {group.items.map((f, i) => (
                    <AccordionItem key={i} value={`${gi}-${i}`} className="border-border">
                      <AccordionTrigger
                        data-testid={`faq-trigger-${gi + 1}-${i + 1}`}
                        className="text-left font-heading text-base font-medium text-foreground hover:text-terracotta-500 hover:no-underline"
                      >
                        {f.q}
                      </AccordionTrigger>
                      <AccordionContent className="text-sm leading-relaxed text-muted-foreground">
                        {f.a}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <CTASection
        title="Still have a question?"
        subtitle="Reach out — a real person reads every message."
        buttonLabel="Contact Us"
        buttonTo="/contact"
      />
    </>
  );
}
